import { isUndefined, noop } from 'lodash';
import { useTranslation } from 'react-i18next';
import LearningPath from 'domains/learning-path/Page';
import { AssignmentPreviewWarningBanner } from 'domains/assignments/Components/AssignmentPreviewBanner';
import { useNavigation } from 'utils/hooks/useNavigation';

export const PreviewLearningPath = (): JSX.Element | null => {
  const { t } = useTranslation();
  const { params } = useNavigation();

  const { learningPathId } = params;
  if (isUndefined(learningPathId)) {
    throw new Error(t('notFound.pageTitle'));
  }

  return (
    <>
      <AssignmentPreviewWarningBanner />
      <div className="mb-128">
        <LearningPath learningPathId={learningPathId} onSubmit={noop} />
      </div>
    </>
  );
};
